import React from 'react';
import { Popover } from 'antd';
import "./CustomPopOver.scss";

const CustomPopOver = ({title, content, placement, children, classname}) => {
    return (
        <div className={classname}>
            <Popover placement={placement} title={title} content={content}
                trigger='hover' 
                autoAdjustOverflow={true}>
                <div className='popover-child-div'>{children}</div>
            </Popover>
        </div>
    );
};

export default CustomPopOver;
